module.exports = __webpack_public_path__ + "static/media/affiliateMembershipType.b10d57de.png";